import { useTranslation } from 'next-i18next'

import DropdownMenu from '~/components/DropdownMenu/DropdownMenu'
import MultiSelect from '~/components/MultiSelect'
import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { FieldError } from '~/components/FieldError'
import { Trait } from '~/types/booking'
import { UserRole } from '~/types/user-info-types'

export default function Traits({ role }: { role: UserRole }): React.ReactElement {
  const namespace = role === UserRole.TUTOR ? 'tutorPanel' : 'studentPanel'
  const { t } = useTranslation(['booking', namespace])

  const { fields, errors, setFields } = useSettingsFormContext()
  const dropdownMenuHeader = t(`${namespace}:settings.labelTraits`)
  const selectedStateLabel = fields.traits.map((elem) => t(`booking:traits.${elem}`)).join(', ')

  const handleOnClick = (item: Trait): void => {
    setFields((prevState) => {
      const prevItems = prevState.traits
      const isExistingItem = prevItems.includes(item)

      if (role === UserRole.USER && prevState.traits.length >= 3 && !isExistingItem) {
        return prevState
      }

      return {
        ...prevState,
        traits: !isExistingItem ? [...prevItems, item] : prevItems.filter((elem) => elem !== item),
      }
    })
  }

  const items = Object.values(Trait).map((elem) => ({
    value: elem,
    label: t(`booking:traits.${elem}`),
  }))

  return (
    <div>
      <DropdownMenu header={dropdownMenuHeader} selectedStateLabel={selectedStateLabel}>
        <div className="space-y-1">
          <span className="text-xxs text-gray-light-fade leading-3">
            {t('studentPanel:settings.descriptionTraits')}
          </span>
          <MultiSelect handleOnClick={handleOnClick} items={items} state={fields.traits} />
        </div>
      </DropdownMenu>
      <FieldError error={errors.traits} />
    </div>
  )
}
